/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class MeevoSignature implements angular.IDirective {
        restrict: 'E';
        templateUrl = 'app/components/controls/signature/signatureTemplate.html';
        scope = {
            currentValue: '=ngModel',
            height: '@?',
            width: '@?',
            disabled: '=ngDisabled',
            required: '=?ngRequired',
            isInitials: '=?',
            backgroundUrl: '@?',
            captureFn: '=?',
            hasContent: '=?',
            preloadOnCanvas: '=?'
        };

        controller = [
            '$scope',
            '$timeout',
            function ($scope, $timeout) {
                $scope.isEmpty = true;

                $scope.save = () => {
                    if (!$scope.signaturePad.isEmpty()) {
                        $scope.currentValue = $scope.signaturePad.toDataURL();
                        $scope.isEmpty = false;
                    }

                    return $scope.currentValue;
                };

                $scope.captureFn = $scope.save;

                $scope.clear = () => {
                    $scope.currentValue = '';
                    $scope.isEmpty = true;
                    $scope.hasContent = false;
                    $scope.signaturePad.clear();

                    if ($scope.backgroundUrl) {
                        $scope.signaturePad.fromDataURL($scope.backgroundUrl);
                    }
                    if ($scope.onResize) {
                        $timeout(() => $scope.onResize());
                    }
                };
            }
        ];

        link = (scope, element, $window) => {
            let canvas = element.find('canvas')[0];

            scope.onResize = function () {
                let ratio = Math.max(window.devicePixelRatio || 1, 1);

                canvas.width = (scope.imageWidth || canvas.offsetWidth) * ratio;
                canvas.height = (scope.imageHeight || canvas.offsetHeight) * ratio;
                canvas.getContext('2d').scale(ratio, ratio);


                if (scope.backgroundUrl) {
                    scope.signaturePad.fromDataURL(scope.backgroundUrl);
                } else if (scope.preloadOnCanvas && scope.currentValue) {
                    scope.signaturePad.fromDataURL(scope.currentValue);
                }

                try {
                    scope.apply();
                } catch (e) {
                }
            };

            scope.signaturePad = new window['SignaturePad'](canvas, {
                onEnd: () => {
                    scope.$apply(() => {
                        scope.hasContent = !scope.signaturePad.isEmpty();
                    });
                }
            });

            const drawPreload = (src: string, sizeFromImage: boolean) => {
                const img = new Image();
                img.onload = function () {
                    if (sizeFromImage) {
                        scope.imageWidth = (this as HTMLImageElement).width;
                        scope.imageHeight = (this as HTMLImageElement).height;
                    }
                    scope.onResize();
                }
                img.src = src;
            };

            if (scope.backgroundUrl) {
                drawPreload(scope.backgroundUrl, true);
            } else if (scope.preloadOnCanvas && scope.currentValue) {
                drawPreload(scope.currentValue, false);
            } else {
                this.$timeout(() => scope.onResize(), 100);

                if (scope.preloadOnCanvas) {
                    const stopWatch = scope.$watch('currentValue', (newVal, oldVal) => {
                        if (newVal && newVal !== oldVal) {
                            drawPreload(newVal, false);
                            stopWatch();
                        }
                    });
                }
            }

            angular.element($window).bind('resize', function () {
                scope.onResize();
            });
        };

        constructor(private $timeout: ng.ITimeoutService) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => {
                return new MeevoSignature($timeout);
            };

            directive.$inject = ['$timeout'];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoSignature', MeevoSignature.factory());
}
